import { useEffect, useRef, useState } from "react";
import Grid, { GridColumn, GridHeader, GridRow } from "../../components/Grid/Grid";
import WebService from "../../utility/WebService";
import HelperService from "../../utility/HelperService";
import PageTitle from "../../components/PageTitle/PageTitle";
import { permissionsInterface } from "../onBoarding/onBoardingTypes";
import { useSelector } from "react-redux";
import { Pencil, Plus, Trash } from "react-bootstrap-icons";
import { toast } from "react-toastify";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import AddStock from "./AddStock";
import { Button } from "react-bootstrap";
import API from "../../utility/API-endPoints";
import { PiExport } from "react-icons/pi";

const headers: GridHeader[] = [
    {
        title: "Name",
        class: "text-left",
        isSorting: true,
        isAsc: true,
        sortingKey: "name",
    },
    {
        title: "Unit",
        class: "text-left",
        isSorting: false,
    },
    {
        title: "Is Royalty Applicable",
        class: "text-left",
        isSorting: false
    },
    {
        title: "Action",
        class: "text-center freeze-column",
        headerClass: "text-center",
        isSorting: false,
        isFilter: false,
        isFreeze: true,
    },
];

const Stock = () => {
    const token = useSelector((state: any) => state.OnBoardingReducer);
    const nextOffset = useRef<number>(0);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [rows, setRows] = useState<GridRow[]>([]);
    const [permissions, setPermissions] = useState<permissionsInterface | null>(null);
    const [showDeleteModal, setDeleteModal] = useState<boolean>(false);
    const [showAddAgent, setShowAddAgent] = useState<boolean>(false);
    const [editData, setEditData] = useState<any>({});
    const [agentId, setAgentId] = useState<string>("");
    const [keyword, setKeyword] = useState<string>("");
    const [totalCount, setTotalCount] = useState<number>(0);

    useEffect(() => {
        if (token && token.token && token.permissions && !!token.permissions.length) {
            setPermissions(token.permissions.find((item: any) => item.name === "STOCK"));
        }
    }, [token])

    const getStockList = (
        offset: number,
        keyword?: string,
        startDate?: Date,
        endDate?: Date,
        order_by?: string,
        sort_by?: string
    ) => {
        nextOffset.current = offset;
        if (nextOffset.current < 0 || isLoading) {
            return;
        }
        nextOffset.current == 0 && setIsLoading(true);
        WebService.getAPI({
            action: `${API.STOCK_LIST}?limit=10&offset=${offset}&keyword=${keyword ? keyword : ""
                }&sort_by=${order_by ?? "asc"}&order_by=${sort_by ?? "created_at"}&from_date=${startDate ? startDate : ""}&to_date=${endDate ? endDate : ""
                }`,
            body: null,
        })
            .then((res: any) => {
                setIsLoading(false);
                let rows: GridRow[] = [];
                for (var i in res.list) {
                    let columns: GridColumn[] = [];
                    columns.push({ value: res.list[i].name ? res.list[i].name : "N/A" });
                    columns.push({ value: res.list[i].unit ? res.list[i].unit?.name : "N/A" });
                    columns.push({ value: res.list[i].is_royalty_applicable ? "Yes" : "No" });
                    columns.push({ value: actionList(res.list[i]), type: "COMPONENT" });
                    rows.push({ data: columns });
                }
                setRows(rows);
                setKeyword(keyword ?? "");
                setTotalCount(res.count ?? 0);
            })
            .catch((e) => {
                setIsLoading(false);
            });
    };

    const onSortList = (offset: number, isAscending?: boolean, key?: string) => {
        getStockList(
            offset,
            null as any,
            null as any,
            null as any,
            isAscending ? "asc" : "desc",
            key
        );
    };

    const actionList = (data: any) => {
        return (
            <div className="action-btns">
                {permissions && permissions.can_update && <button className="cursor-pointer  btn-edit btn" onClick={() => onEdit(data)}>{" "}<Pencil />{" "}</button>}
                {permissions && permissions.can_delete && <button onClick={() => onConfirmDelete(data)} className="cursor-pointer btn btn-delete" > {" "} <Trash />{" "}  </button>}
            </div>
        );
    };

    const onEdit = (val: any) => {
        setEditData(val);
        setShowAddAgent(true);
    };

    const onConfirmDelete = (val: any) => {
        setAgentId(val.uuid);
        setDeleteModal(true);
    };

    const onDelete = () => {
        setDeleteModal(false);
        setIsLoading(true);
        WebService.deleteAPI({
            action: `stock/delete/${agentId}`,
            body: null,
        })
            .then((res: any) => {
                setIsLoading(false);
                toast.success(res.message);
                setAgentId("");
                getStockList(1);
            })
            .catch((e) => {
                setIsLoading(false);
                setAgentId("");
            });
    };

    const onCloseUserModal = (e: boolean) => {
        setShowAddAgent(false);
        setEditData({});
        e && getStockList(1);
    };

    const exportStocks = () => {
        WebService.getAPI({
            action: `stock/export?keyword=${keyword ? keyword : ""}`,
            body: null,
            responseType: 'arraybuffer',
        }).then((response: any) => {
            const url = window.URL.createObjectURL(new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `stocks_${new Date().toISOString()}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        }).catch((e) => {
            toast.error("Failed to export stocks");
        });
    };

    return (
        <>
            <AddStock isShow={showAddAgent} isClose={(e: boolean) => { onCloseUserModal(e); }} data={editData} />
            <DeleteModal isShow={showDeleteModal} close={() => { setDeleteModal(false); }} onDelete={() => { onDelete(); }} />
            {permissions && permissions.can_read && <div className="app-page page-dashboard">
                <div className="d-flex justify-content-between align-items-center  mb-2"> <PageTitle title="Raw Material" backArrow={false} />
                    <div>
                        {permissions && permissions.can_write && <Button className="btn btn-brand-1" onClick={() => { setEditData({}); setShowAddAgent(true); }} >
                            <Plus size={20} className="ms-1" /> Add Raw Material
                        </Button>}
                        {permissions && permissions.can_write && permissions.can_update && <Button className="btn btn-brand-1 ms-2" onClick={() => { exportStocks(); }} >
                            <PiExport size={20} className="ms-1" /> Export Raw Material
                        </Button>}
                    </div>
                </div>
                <div className="table-card">
                    <Grid
                        rows={rows}
                        showSearch={true}
                        headers={headers}
                        showDateFilter={false}
                        onPageChange={getStockList}
                        errorMessage={"No Raw Material Found"}
                        ShowLoader={isLoading}
                        onSort={onSortList}
                        count={totalCount}
                    />
                </div>
            </div>}
        </>
    );
};

export default Stock;
